import React, { Component } from 'react';
import numeral from 'numeral';
import { reverse } from 'named-urls';
import { Link } from 'react-router-dom';
import routes from '@achievable-me/tundra-wizard/routes';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import SpinnerError from '$components/library/SpinnerError';

import styles from './styles.scss';

const STAFF_PRODUCT_STATS = gql`
  query StaffProductStats($input: StaffProductStatsInput!) {
    staffProductStats(input: $input) {
      stats
    }
  }
`;

class Card extends Component {
  render() {
    const { children, title } = this.props;

    return (
      <div className={styles.cardLayout}>
        <div className={styles.cardTitle}>{title}</div>
        <div className={styles.cardContent}>{children}</div>
      </div>
    );
  }
}

const ProductOverview = (props) => {
  const { match } = props;
  const { params } = match;
  const { productSlug } = params;

  return (
    <div className={styles.layout}>
      <Link to={reverse(routes.study.dashboard, { productSlug })}>
        View student version
      </Link>
      <Query query={STAFF_PRODUCT_STATS} variables={{ input: { productSlug } }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const { staffProductStats } = data;

          const { stats } = staffProductStats;
          const { debug, totals } = stats;
          const { now } = debug;
          const {
            totalSubscriptions,
          } = totals;

          return (
            <div>
              <div className={styles.cards}>
                <Card title="Overall stats">
                  <div>
                    Total subscriptions: {numeral(totalSubscriptions).format('0,0')}
                  </div>
                </Card>
              </div>
              <div>Generated at {now}</div>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default ProductOverview;
